import { useState } from "react";
import { X } from "lucide-react";

const DAYS = [
  { key: "mon", label: "Mon" },
  { key: "tue", label: "Tue" },
  { key: "wed", label: "Wed" },
  { key: "thu", label: "Thu" },
  { key: "fri", label: "Fri" },
  { key: "sat", label: "Sat" },
  { key: "sun", label: "Sun" },
];

export function AvailabilityEditor({ value, onChange }) {
  const [draft, setDraft] = useState({ day: "mon", start: "08:00", end: "22:00" });

  const add = () => {
    if (draft.start >= draft.end) return;
    const next = { ...(value || {}) };
    next[draft.day] = [...(next[draft.day] || []), { start: draft.start, end: draft.end }];
    onChange(next);
  };

  const remove = (day, idx) => {
    const next = { ...(value || {}) };
    next[day] = (next[day] || []).filter((_, i) => i !== idx);
    if (next[day].length === 0) delete next[day];
    onChange(next);
  };

  return (
    <div className="border hairline p-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2 items-end">
        <div>
          <div className="tick-label mb-1">Day</div>
          <select
            data-testid="avail-day"
            value={draft.day}
            onChange={(e) => setDraft({ ...draft, day: e.target.value })}
            className="w-full border hairline px-3 py-2.5 focus:outline-none focus:border-[#FF3B30]"
          >
            {DAYS.map((d) => (<option key={d.key} value={d.key}>{d.label}</option>))}
          </select>
        </div>
        <div>
          <div className="tick-label mb-1">Start</div>
          <input data-testid="avail-start" type="time" value={draft.start} onChange={(e) => setDraft({ ...draft, start: e.target.value })} className="w-full border hairline px-3 py-2.5 focus:outline-none focus:border-[#FF3B30]" />
        </div>
        <div>
          <div className="tick-label mb-1">End</div>
          <input data-testid="avail-end" type="time" value={draft.end} onChange={(e) => setDraft({ ...draft, end: e.target.value })} className="w-full border hairline px-3 py-2.5 focus:outline-none focus:border-[#FF3B30]" />
        </div>
        <button type="button" data-testid="avail-add" onClick={add} className="btn-outline">Add window</button>
      </div>

      <div className="mt-5 grid grid-cols-1 sm:grid-cols-7 gap-2">
        {DAYS.map((d) => (
          <div key={d.key} className="border hairline p-3 min-h-[92px]">
            <div className="tick-label mb-2">{d.label}</div>
            {(value?.[d.key] || []).length === 0 ? (
              <div className="text-neutral-600 text-xs">Closed</div>
            ) : (
              (value[d.key] || []).map((w, i) => (
                <div key={i} data-testid={`avail-window-${d.key}-${i}`} className="flex items-center justify-between font-mono text-xs mb-1">
                  <span>{w.start}–{w.end}</span>
                  <button type="button" onClick={() => remove(d.key, i)}><X size={11} className="text-neutral-500 hover:text-[#FF3B30]" /></button>
                </div>
              ))
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function AvailabilityDisplay({ value }) {
  if (!value || Object.keys(value).length === 0) {
    return <div className="text-neutral-500 text-sm mt-3">Contact host for availability.</div>;
  }
  return (
    <div className="mt-4 grid grid-cols-2 md:grid-cols-7 gap-2">
      {DAYS.map((d) => (
        <div key={d.key} className="border hairline p-3">
          <div className="tick-label mb-2">{d.label}</div>
          {(value[d.key] || []).length === 0 ? (
            <div className="text-neutral-600 text-xs">Closed</div>
          ) : (
            value[d.key].map((w, i) => (
              <div key={i} className="font-mono text-xs mb-1">{w.start}–{w.end}</div>
            ))
          )}
        </div>
      ))}
    </div>
  );
}
